var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.638 13.3605C15.106 12.5865 15.322 11.8305 15.34 10.7685C15.34 8.03249 13.432 5.87249 10.606 5.87249C7.78 5.87249 5.872 8.03249 5.872 10.7685C5.872 13.4865 7.78 15.6465 10.606 15.6465C11.938 15.6285 12.604 15.3225 13.378 14.7465L11.668 12.9285L13.036 11.6325L14.638 13.3605ZM4 10.7685C4 7.04249 6.718 4.00049 10.606 4.00049C14.494 4.00049 17.194 7.04249 17.194 10.7685C17.176 12.3165 16.744 13.5945 15.952 14.7645L17.374 16.2585L16.042 17.5545L14.674 16.0785C13.54 17.0145 12.46 17.5185 10.606 17.5185C6.718 17.5185 4 14.4765 4 10.7685Z",
    fill: "#BDC1C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionOff);
export default __webpack_public_path__ + "static/media/question_off.aa14ffce10d493258c69aca08ecc84e7.svg";
export { ForwardRef as ReactComponent };